import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { CategoriesRequest } from '../api/categories/categoriesrequest';
import { CategoriesResponse, CategoriesResponseDtoImpl } from '../api/categories/categoriesresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { CategoryBuilder } from '../dto/categories/categorybuilder';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';

export class CategoriesAPIProcessorImpl extends APIProcessorImpl<CategoriesRequest, CategoriesResponse>
{

    execute(request: CategoriesRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new CategoriesResponseDtoImpl(APIFeatures.CATEGORIES, "Get Categories Success");

                let categoriesList = new CategoryBuilder(responseMapper.getResponseMap()).buildAll();
                response.setCategoriesList(categoriesList);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new CategoriesResponseDtoImpl(APIFeatures.CATEGORIES, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new CategoriesResponseDtoImpl(APIFeatures.CATEGORIES, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new CategoriesResponseDtoImpl(APIFeatures.CATEGORIES, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
     
            this.getAPIFailure(new CategoriesResponseDtoImpl(APIFeatures.CATEGORIES, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/categoriesapiprocessor.tsx